import React, { useState } from 'react';
import BaseSidebarPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/BaseSidebarPanel';
import MultiStylePropertyPanel from '../../App/InspectorDrawer/ConfigurationPanel/input-panels/helpers/style-inputs/MultiStylePropertyPanel';
import ContainerBlock from './index';
export default function ContainerSidebarPanel({ data, setData }) {
    const [, setErrors] = useState(null);
    const updateData = (d) => {
        const res = ContainerBlock.schema.safeParse(d);
        if (res.success == true) {
            setData(res.data);
            setErrors(null);
        }
        else {
            setErrors(res.error);
        }
    };
    return (React.createElement(BaseSidebarPanel, { title: "Container block" },
        React.createElement(MultiStylePropertyPanel, { names: ['backgroundColor', 'borderColor', 'borderRadius', 'padding'], value: data.style, onChange: (style) => updateData(Object.assign(Object.assign({}, data), { style })) })));
}
//# sourceMappingURL=ContainerSidebarPanel.js.map